import styled from 'styled-components';

const ViewContainer = styled.div`
   margin: 0 auto;
   padding: 0 25px 20px 25px;
   max-width: 1200px;
   overflow: visible;
`;

export default ViewContainer;
